import { signOut } from "firebase/auth";
import { auth, db } from "./firebase";
import Alert from "@mui/material/Alert";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, addDoc } from "firebase/firestore";
import Singlecomplaint from "./singlecomplaint";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CircularProgress, {
  CircularProgressProps,
} from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function CircularProgressWithLabel(
  props: CircularProgressProps & { value: number }
) {
  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
function Userpage() {
  const [view, setview] = useState("complaints");
  const [type, settype] = useState("Type of block");
  const [newcomplaint, setnewcomplaint] = useState({
    location: "Location of complaint",
    date_time: "",
    contact_no: "Contact no.",
    typeofcomplaint: "",
    description: "Details",
    statusofcomplaint: "Registered",
  });
  const [progress_counter, set_progress_counter] = useState();
  const [getcomplaint, setgetcomplaint] = useState({
    location: "",
    date_time: "",
    typeofcomplaint: "",
    description: "",
    statusofcomplaint: "",
  });

  const navigate = useNavigate();

  const x = "typeofcomplaint";

  //getting hold of current user details, store user details in usestate

  const comref = collection(db, "Complaints");

  const [curr_user_email, setcurr_user_email] = useState(
    localStorage.getItem("emailForSignIn")
  );
  const [curr_user_name, setcurr_user_name] = useState(
    localStorage.getItem("nameForSignIn")
  );
  const [curr_user_id, setcurr_user_id] = useState(
    localStorage.getItem("idForSignIn")
  );

  const [Allcomplaints, setAllcomplaints] = useState([]);

  const ssd = async () => {
    getDocs(comref).then((response) => {
      let complaints = [];
      response.docs.map((item) => {
        let a = item.data();
        a = { ...a, id: item.id };

        if (a.Id_of_user === curr_user_id) complaints = [...complaints, a];
      });

      const fgh = complaints.sort((x, y) => {
        return new Date(y.Date_of_complaint) - new Date(x.Date_of_complaint);
      });

      setAllcomplaints(fgh);
    });
  };

  useEffect(() => {
    if (curr_user_id) {
      ssd();
    }
  }, []);

  //setting type of complaint in the form

  function handlefdk(ve) {
    settype(ve);
    setnewcomplaint((prev) => {
      return {
        ...prev,
        [x]: ve,
      };
    });
  }

  //updating value of fields present in form

  function handlechange(event) {
    const { value, name } = event.target;

    setnewcomplaint((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  }
  const [clicked, setclicked] = useState("none");
  function hadlenewcomplaint() {
    const d = new Date();
    let valid = true;
    if (newcomplaint.contact_no.length != 10) {
      valid = false;
    }

    for (let i = 0; i < newcomplaint.contact_no.length; i++) {
      if (
        !(newcomplaint.contact_no[i] >= 0 && newcomplaint.contact_no[i] <= 9)
      ) {
        valid = false;
        break;
      }
    }
    //hi there

    if (valid === true) {
      addDoc(comref, {
        Name_of_user: curr_user_name,
        Id_of_user: curr_user_id,
        Location_of_complaint: newcomplaint.location,
        Date_of_complaint: d.toISOString(),
        Contact_of_user: newcomplaint.contact_no,
        Type_of_complaint: newcomplaint.typeofcomplaint,
        Description_of_complaint: newcomplaint.description,
        Status_of_complaint: newcomplaint.statusofcomplaint,
      });
      const popy = {
        location: "Location of complaint",
        date_time: "",
        contact_no: "Contact no.",
        typeofcomplaint: "",
        description: "Details",
        statusofcomplaint: "Registered",
      };

      setnewcomplaint((prev) => {
        return {
          ...prev,
          ...popy,
        };
      });
      //after adding complaint to database we set input fields to default values ex.statusofcomplaint: "Registered", as next time this will only decide new status
      settype("Type of block");
      setclicked("success");
    } else {
      setclicked("error");
    }
  }

  function eachcomplaint(onecomplaint) {
    if (onecomplaint.Status_of_complaint === "Registered") {
      set_progress_counter("25");
    } else if (onecomplaint.Status_of_complaint === "Considered") {
      set_progress_counter("50");
    } else if (onecomplaint.Status_of_complaint === "In Progress") {
      set_progress_counter("75");
    } else if (onecomplaint.Status_of_complaint === "Resolved") {
      set_progress_counter("100");
    }
    const pop = {
      location: onecomplaint.Location_of_complaint,
      date_time: onecomplaint.Date_of_complaint,
      typeofcomplaint: onecomplaint.Type_of_complaint,
      description: onecomplaint.Description_of_complaint,
      statusofcomplaint: onecomplaint.Status_of_complaint,
    };

    setgetcomplaint((prev) => {
      return {
        ...prev,
        ...pop,
      };
    });

    handleview("singlecomp");
  }

  //carrying out signout process
  const handleLogOut = async () => {
    signOut(auth)
      .then(() => {
        localStorage.removeItem("emailForSignIn");
        localStorage.removeItem("nameForSignIn");
        localStorage.removeItem("idForSignIn");
        navigate("/");
      })
      .catch((error) => {
        alert("failed to logout");
      });
  };

  //changing the view of webpage i.e conditional rendering

  function handleview(s) {
    setview(s);
  }

  if (view === "singlecomp") {
    return (
      <div className="container mt-1">
        <div style={{ backgroundColor: "#343a40" }}>
          <nav class="navbar navbar-expand-lg navbar-dark">
            <a className="navbar-brand" href="http://nitp.ac.in/">
              <img
                src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                alt=""
                width="30"
                height="24"
                margin-right="100"
                className="d-inline-block align-text-top"
              />
              Nit Patna complaint portal
            </a>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                  <a
                    className="nav-link active"
                    aria-current="page"
                    href="#"
                    onClick={() => handleview("complaints")}
                  >
                    My complaints
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={() => handleview("nw")}
                  >
                    Add a new complaint
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#footer">
                    {curr_user_name}
                  </a>
                </li>
                <li class="nav-item">
                  <button
                    className="btn btn-outline-success"
                    type="submit"
                    onClick={handleLogOut}
                  >
                    Log out
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div class="card">
          <h5 class="card-header">
            <ArrowBackIcon onClick={() => handleview("complaints")} />
            Registered on:
            {new Date(getcomplaint.date_time)?.toDateString()}
          </h5>
          <div class="card-body">
            <p class="card-text">
              Location of complaint: {getcomplaint.location}
            </p>
            <p class="card-text">
              Type of complaint: {getcomplaint.typeofcomplaint}
            </p>
            <p class="card-text">Description: {getcomplaint.description}</p>
            <p class="card-text">
              current status: {getcomplaint.statusofcomplaint}
            </p>
            <CircularProgressWithLabel value={progress_counter} />
          </div>
        </div>
      </div>
    );
  }

  //if user want's to see all complaints made then return this
  if (view === "complaints") {
    return (
      <div className="container mt-1">
        <div style={{ backgroundColor: "#343a40" }}>
          <nav class="navbar navbar-expand-lg navbar-dark">
            <a className="navbar-brand" href="http://nitp.ac.in/">
              <img
                src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                alt=""
                width="30"
                height="24"
                margin-right="100"
                className="d-inline-block align-text-top"
              />
              Nit Patna complaint portal
            </a>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                  <a
                    className="nav-link active"
                    aria-current="page"
                    href="#"
                    onClick={() => handleview("complaints")}
                  >
                    My complaints
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={() => handleview("nw")}
                  >
                    Add a new complaint
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#footer">
                    {curr_user_name}
                  </a>
                </li>
                <li class="nav-item">
                  <button
                    className="btn btn-outline-success"
                    type="submit"
                    onClick={handleLogOut}
                  >
                    Log out
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </div>
        <div class="container mt-4">
          {Allcomplaints.map((onecomp) => {
            return (
              <div class="container mt-4">
                <div class="card">
                  <h5 class="card-header">
                    Registered on:{" "}
                    {new Date(onecomp.Date_of_complaint)?.toDateString()}
                  </h5>
                  <div class="card-body">
                    <h5 class="card-title">
                      Location of complaint: {onecomp.Location_of_complaint}
                    </h5>

                    <p class="card-text">
                      Type of complaint: {onecomp.Type_of_complaint}
                    </p>

                    <p
                      class="btn btn-outline-success"
                      onClick={() => eachcomplaint(onecomp)}
                    >
                      See details
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  //if user want's to make new complaint then return this
  if (view === "nw") {
    return (
      <div className="container mt-1">
        <div style={{ backgroundColor: "#343a40" }}>
          <nav class="navbar navbar-expand-lg navbar-dark">
            <a className="navbar-brand" href="http://nitp.ac.in/">
              <img
                src="https://nitp.ac.in/static/logo512-579d034908ae89b5e0243d1274937d5d.png"
                alt=""
                width="30"
                height="24"
                margin-right="100"
                className="d-inline-block align-text-top"
              />
              Nit Patna complaint portal
            </a>
            <button
              class="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                  <a
                    className="nav-link active"
                    aria-current="page"
                    href="#"
                    onClick={() => handleview("complaints")}
                  >
                    My complaints
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    className="nav-link"
                    href="#"
                    onClick={() => handleview("nw")}
                  >
                    Add a new complaint
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#footer">
                    {curr_user_name}
                  </a>
                </li>
                <li class="nav-item">
                  <button
                    className="btn btn-outline-success"
                    type="submit"
                    onClick={handleLogOut}
                  >
                    Log out
                  </button>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="container mt-1">
          <form>
            <div className="mb-3">
              <label for="exampleFormControlInput1" className="form-label">
                Location
              </label>
              <input
                className="form-control"
                id="exampleFormControlInput1"
                value={newcomplaint.location}
                name="location"
                onChange={handlechange}
              />
            </div>
            <div className="mb-3">
              <label for="exampleFormControlInput1" className="form-label">
                Contact no.
              </label>
              <input
                className="form-control"
                id="exampleFormControlInput1"
                value={newcomplaint.contact_no}
                name="contact_no"
                onChange={handlechange}
              />
            </div>

            <label for="exampleFormControlInput1" className="form-label">
              Complaint type
            </label>
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                aria-label="Text input with dropdown button"
                disabled="true"
                value={type}
              />
              <button
                className="btn btn-outline-secondary dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              ></button>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handlefdk("Academic")}
                  >
                    Academic
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handlefdk("Administration")}
                  >
                    Administration
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    onClick={() => handlefdk("Residential")}
                  >
                    Residential
                  </a>
                </li>
              </ul>
            </div>

            <div className="mb-3">
              <label for="exampleFormControlTextarea1" className="form-label">
                Description
              </label>
              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows="3"
                name="description"
                value={newcomplaint.description}
                onChange={handlechange}
              ></textarea>
            </div>
            <button
              type="button"
              className="btn btn-dark"
              disabled={
                type === "Type of block" ||
                newcomplaint.description === "Details" ||
                newcomplaint.contact_no === "Contact no." ||
                newcomplaint.location === "Location of complaint"
              }
              onClick={hadlenewcomplaint}
            >
              Register complaint
            </button>
          </form>
          <div
            style={{ visibility: clicked === "success" ? "visible" : "hidden" }}
          >
            <Alert onClose={() => setclicked("none")}>
              Complaint registered successfully!
            </Alert>
          </div>
          <div
            style={{ visibility: clicked === "error" ? "visible" : "hidden" }}
          >
            <Alert severity="error" onClose={() => setclicked("none")}>
              Enter correct contact details!
            </Alert>
          </div>
        </div>
      </div>
    );
  }
}
export default Userpage;
